// extracted by mini-css-extract-plugin
export default {"container":"B1Q2NsqYrh_cYFLIgCpV","containerMobile":"m0bFjOawckA7sf3jhhCy"};